import { render } from "./verificationComponent.vue?vue&type=template&id=6d6bc165"
import script from "./verificationComponent.vue?vue&type=script&lang=js"
export * from "./verificationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__